<template>
  <div class="main">
    <span>升级会员页面</span>
    <div class="el">
      <div class="el-item">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="课程话题" name="first">
          <div class="Discussions-empty-list">
            <div class="Discussions-empty">您还没有发表过话题</div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="班级话题" name="second">
          <div class="Discussions-empty-list">
            <div class="Discussions-empty">您还没有发表过话题</div>
          </div>
        </el-tab-pane>
        </el-tabs>
      </div>
    </div>
   
  </div>
</template>

<script>
export default {
  name: 'Member',
  data() {
      return {
        activeName: 'first'
      };
    },
    methods: {
      // handleClick(tab, event) {
      //   console.log(tab, event);
      // }
    }
}
</script>

<style lang="scss" scoped>
   .main{
    span{
      display: flex;
    }
    .el{
      border-top: 1px solid #f5f5f5;
      margin-top: 10px;
     .el-item{
        margin-top: 20px;
        .Discussions-empty-list{
          list-style: none;
          margin: 0;
          padding: 0;
          .Discussions-empty{
            text-align: center;
            color: #c1c1c1;
            padding: 20px 0;
            margin-top: 15px;
          }
        }
      }
    }
  }
</style>